import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import api, { getCsrfToken } from '../api/axios';

function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('member_user') || 'null'));

  useEffect(() => {
    api.get('/api/member/me')
      .then(res => {
        setUser(res.data);
        localStorage.setItem('member_user', JSON.stringify(res.data));
      })
      .catch(() => {
        setUser(null);
        localStorage.removeItem('member_user');
      });
  }, [location.pathname]);

  const handleLogout = async () => {
    try {
      await getCsrfToken();
      await api.post('/api/member/logout');
    } catch (e) {
      // ignore
    }
    setUser(null);
    localStorage.removeItem('member_user');
    navigate('/');
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark shadow-sm">
      <div className="container">
        <Link className="navbar-brand fw-bold text-warning" to="/">Conexsee</Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon" />
        </button>

        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <Link
                className={`nav-link ${location.pathname === '/' ? 'active text-warning' : 'text-light'}`}
                to="/"
              >
                Home
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className={`nav-link ${location.pathname === '/about' ? 'active text-warning' : 'text-light'}`}
                to="/about"
              >
                About Us
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className={`nav-link ${location.pathname === '/feedback' ? 'active text-warning' : 'text-light'}`}
                to="/feedback"
              >
                Feedback
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className={`nav-link ${location.pathname.startsWith('/webinar') ? 'active text-warning' : 'text-light'}`}
                to="/webinar"
              >
                Webinar
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className={`nav-link ${location.pathname.startsWith('/promo-merdeka') || location.pathname.startsWith('/merdeka') || location.pathname.startsWith('/kelas') ? 'active text-warning' : 'text-light'}`}
                to="/promo-merdeka"
              >
                Kelas
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className={`nav-link ${location.pathname.startsWith('/post-webinar') ? 'active text-warning' : 'text-light'}`}
                to="/post-webinar"
              >
                Post Webinar
              </Link>
            </li>

            {user ? (
              <>
                <li className="nav-item">
                  <Link
                    className={`nav-link ${location.pathname.startsWith('/my-classes') ? 'active text-warning' : 'text-light'}`}
                    to="/my-classes"
                  >
                    My Course
                  </Link>
                </li>
                <li className="nav-item dropdown">
                  <span
                    className="nav-link dropdown-toggle text-light"
                    role="button"
                    data-bs-toggle="dropdown"
                  >
                    {user.name}
                  </span>
                  <ul className="dropdown-menu dropdown-menu-end">
                    <li><span className="dropdown-item-text small text-muted">{user.phone}</span></li>
                    <li><hr className="dropdown-divider" /></li>
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/profile"
                        onClick={() => {
                          const toggler = document.getElementById('navbarNav');
                          if (toggler && toggler.classList.contains('show')) {
                            toggler.classList.remove('show');
                          }
                        }}
                      >
                        Pengaturan Profil
                      </Link>
                    </li>
                    <li>
                      <button className="dropdown-item" onClick={handleLogout}>
                        Logout
                      </button>
                    </li>
                  </ul>
                </li>
              </>
            ) : (
              <li className="nav-item">
                <Link
                  className={`nav-link ${location.pathname === '/login' ? 'active text-warning' : 'text-light'}`}
                  to="/login"
                >
                  Login
                </Link>
              </li>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
